<!-- Hero Section -->
<ng-container *ngIf="initialized && userSubscription &&  userSubscription.hasSubscription">
  <div class="row mb-3">
    <div class="col-md-6">
      <h4>Payment Method</h4>
    </div>
  </div>
  <div *ngIf="userSubscription.hasCardOnFile" class="row">
    <div class="col-md-12">
      <div class="card p-0">
        <div class="card-body p-0">
          <div class="row">
            <div class="col-md-12">
              <table class="table table-hover mb-0">
                <thead class="bg-light">
                <tr>
                  <th>Type</th>
                  <th>Card Number</th>
                  <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    Credit Card
                  </td>

                  <td>
                    <img style="height: 30px" src="/assets/{{userSubscription.cardBrand}}.png"/>
                    ***** {{ userSubscription.paymentMethodLast4 }}
                  </td>

                  <td class="text-right">
                    <button class="btn btn-xs btn-secondary " (click)="addCard()" type="button" id="dropdownMenuButton">Change</button>

                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="userSubscription.hasSubscription" class="card mt-5">
    <div class="row ">
      <div class="col-md-6">
        <table style="border-spacing: .8rem; border-collapse: separate">
          <tr>
            <td><strong>Start Date</strong></td>
            <td>{{ subscription.startDate | date }}</td>
          </tr>
          <tr>
            <td><strong>Current Period</strong>
            </td>
            <td>{{ subscription.currentPeriodStart | date }} - {{ subscription.currentPeriodEnd | date }}</td>
          </tr>
          <tr *ngIf="auth.isSuperUser()">
            <td><strong>Subscription Id</strong>
            </td>
            <td>
              <a href="https://dashboard.stripe.com/subscriptions/{{subscription.id}}">{{ subscription.id }}</a>
            </td>
          </tr>
        </table>

      </div>
    </div>
    <table class="table">
      <thead>
      <tr>
        <th>Product</th>
        <th>Qty</th>
        <th>Total</th>
      </tr>
      </thead>
      <tr *ngFor="let item of subscription.items">
        <td>{{ item.productName }}
          <div class="d-flex text-right mr-2">
            <span *ngIf="item.usageType == 'metered'">TBD</span>
            <span *ngIf="item.usageType != 'metered'">{{ item.unitAmount|currency }}</span>
            <span class="ml-1" *ngIf="item.recurring"> / {{ item.interval }}</span>
          </div>
        </td>
        <td>{{ item.qty }}</td>
        <td>{{ item.qty * item.unitAmount |currency }}</td>
      </tr>
    </table>
  </div>
</ng-container>
<ng-container *ngIf="!userSubscription || !userSubscription.hasSubscription">
  <div class="bg-img-hero" style="background-image: url(../../assets/img/1920x800/subscription.png);">
    <div class="container space-2 space-lg-3">
      <div class="w-md-65 w-lg-35">
        <div class="mb-4">
          <h1 class="font-weight-semi-bold text-white">Subscribe to {{ settings.brand.brandName }}</h1>
          <p class="text-white">Earn unlimited CEUs, Conference discounts and exclusive member perks all for one low monthly price!</p>
        </div>
        <button type="button" class="btn btn-primary btn-pill transition-3d-hover px-5" (click)="addSubscription()">Subscribe Now</button>
      </div>
    </div>
  </div>

  <!-- End Hero Section -->
  <!-- Pricing Section -->
  <div class="">
    <!-- Pricing -->
    <div class="row no-gutters align-items-lg-center">
      <div class="col-lg-7 shadow-lg rounded">
        <div class="text-center py-11 px-5 px-sm-9">
          <header class="mb-9">
            <div class="mb-1">
              <span class="display-4 text-primary font-weight-medium">$24.95</span>
            </div>
            <p>per month</p>
          </header>

          <div class="row justify-content-sm-center align-items-sm-center mb-5">
            <div class="col-sm-5">
              <!-- Icon Block -->
              <figure id="iconAccount" class="svg-preloader ie-height-56 max-width-8 mx-auto mb-2">
                <img class="js-svg-injector" src="../../assets/svg/illustrations/account-creation.svg" alt="SVG"
                     data-parent="#iconAccount">
              </figure>
              <h4 class="h6">Unlimited Access</h4>
              <!-- End Icon Block -->
            </div>

            <div class="col-sm-1 my-3 my-sm-0">
              <span class="font-size-3 text-primary font-weight-medium">+</span>
            </div>

            <div class="col-sm-5">
              <!-- Icon Block -->
              <figure id="iconProAccount" class="svg-preloader ie-height-56 max-width-8 mx-auto mb-2">
                <img class="js-svg-injector" src="../../assets/svg/illustrations/pro-account.svg" alt="SVG"
                     data-parent="#iconProAccount">
              </figure>
              <h4 class="h6">Event Discounts</h4>
              <!-- End Icon Block -->
            </div>
          </div>

          <div class="mb-7">
            <p class="small">Automatically recurring
              <br>until cancelled
            </p>
          </div>

          <button type="button" (click)="addSubscription()" class="btn btn-primary btn-wide btn-pill transition-3d-hover">Subscribe Now</button>
        </div>
      </div>

      <div class="col-lg-5 bg-primary">
        <div class="py-9 px-5 px-sm-9">
          <!-- Info -->
          <ul class="list-unstyled">
            <li class="media pb-3">
            <span class="btn btn-icon btn-xs btn-soft-white rounded-circle mt-1 mr-3">
              <span class="fas fa-angle-right btn-icon__inner"></span>
            </span>
              <div class="media-body">
                <h4 class="h6 text-white mb-1">1500+ on-demand CEU videos</h4>
                <p class="text-white-70">Access a large portion of our CEU library and watch unlimited.</p>
              </div>
            </li>
            <li class="border-top opacity-md py-3"></li>
            <li class="media">
            <span class="btn btn-icon btn-xs btn-soft-white rounded-circle mt-1 mr-3">
              <span class="fas fa-angle-right btn-icon__inner"></span>
            </span>
              <div class="media-body">
                <h4 class="h6 text-white mb-1">10% off conference registration</h4>
                <p class="text-white-70">{{ settings.brand.brandName }} members get exclusive discounts to conferences and events.</p>
              </div>
            </li>
            <li class="border-top opacity-md py-3"></li>
            <li class="media">
            <span class="btn btn-icon btn-xs btn-soft-white rounded-circle mt-1 mr-3">
              <span class="fas fa-angle-right btn-icon__inner"></span>
            </span>
              <div class="media-body">
                <h4 class="h6 text-white mb-1">10% off live events</h4>
                <p class="text-white-70 mb-0">Take an extra 10% off 1 live event each month!</p>
              </div>
            </li>
          </ul>
          <!-- End Info -->
        </div>
      </div>
    </div>
    <div class="mt-2">
      <small>
        <i>
          <ul>
            <li>To prevent abuse, subscriptions must remain active for a minimum of 6 months from the starting date to be eligible for CEU content. If a subscription is canceled within that window and content has been consumed, the account will be charged a cancellation fee equal to 6 months.</li>
            <li>Users who claim a conference discount must have an active membership for at least 6 months before or after purchase. If cancelled within that period, user will be charged the discounted amount.</li>
            <li>Individual contributors on the platform can decide whether to make their content eligible for the subscription. Not all content will be eligible. You can filter your on-demand library to see content included in your subscription. Currently over 1500 videos with CEUs are available.</li>
            <li>If/when you cancel your subscription, you loose access to any content you added as part of your subscription. Earned CEUs will remain in your account forever</li>
            <li>Subscriptions canceled within 90 days of the starting date will no longer be eligible for subscriptions in the future.</li>
          </ul>
        </i></small></div>
    <!-- End Pricing -->
  </div>
  <!-- End Pricing Section -->
</ng-container>
